<template>
  <material-card color="orange" title="Audit Trail">
    <v-data-table class="audit_trail_table" style="width: 100%" fixed-header small density="compact" :loading="loading"
      hide-default-footer hide-default-header hide-footer :items-per-page='-1' :headers="headers" :items="filteredItems"
      :item-class="itemStyle">
      <template slot="header">
        <thead class='v-data-table-header'>
          <tr>
            <th :style="{ width: `${header.width}px` }" :key="header.value" v-for="header in headers" :class="`text-${header.align || 'left'}`">
              <span class="text--lighten-4">
                {{ header.text }}
              </span>
            </th>
          </tr>
          <tr>
            <th v-for="header in headers" :key="header.value" :class="`text-${header.align || 'left'}`">
              <v-text-field v-if="['account', 'field_name'].includes(header.value)" placeholder="Search"
                autocomplete="off" clearable density="compact" hide-details variant="underlined" color="success"
                v-model="localFilters[header.value]" />

              <template v-if="header.value === 'datetime'">
                <input type="date" v-model="localFilters.start_date" />
                <input type="date" v-model="localFilters.end_date" />
              </template>
              <br>
            </th>
          </tr>
        </thead>
      </template>
    </v-data-table>
  </material-card>
</template>

<script>
import { getList } from '../../api/base_entity'
import $format from '../../utils/formatter'
export default {
  props: {
    entity: String,
    entity_id: [String, Number],
    fields: Array,
    filters: Object,
    hideFields: [Array, Object]
  },
  data() {
    return {
      localFilters: { field_name: '', value: '', prev_value: '', account: '', start_date: '', end_date: '' },
      items: [],
      odd: false,
      opened: false,
      loading: false,
      headers: [
        { value: 'action', text: 'Action', width: 120 },
        { value: 'field_name', text: 'Name', width: 150 },
        { value: 'prev_value', text: 'Before', width: 150 },
        { value: 'value', text: 'After', width: 150 },
        { value: 'account', text: 'Account', width: 170, align: 'right' },
        { value: 'datetime', text: 'Date Time', width: 150, align: 'right' },
      ]
    }
  },
  mounted() {
    this._getData()
  },
  computed: {
    filteredItems() {
      return this.items.filter(i => {

        // field name
        if (this.localFilters.field_name && !i?.field_name?.toLocaleLowerCase().includes(this.localFilters.field_name.toLocaleLowerCase())) {
          return false
        }

        // account 
        if (this.localFilters.account && !i?.account?.toLocaleLowerCase().includes(this.localFilters.account.toLocaleLowerCase())) {
          return false
        }

        if (this.localFilters.start_date && i.datetime < this.localFilters.start_date) {
          return false
        }

        if (this.localFilters.end_date && i.datetime > this.localFilters.end_date) {
          return false
        }

        return i
      })
    }
  },
  methods: {
    itemStyle(item) {
      return item.odd ? 'odd' : ''
    },
    _getFieldLabel(field_name) {
      const field = this?.fields?.find(f => f.value === field_name)
      if(['eCDS Map','SafetyDB Map','REDCap Map'].includes(field_name)){
        return field?.text ?? field_name
      }else{
        return field?.text ?? $format('field_name', field_name)
      }
    },
    async _getData() {
      let accounts = await getList('account',{},{ rowsPerPage: 1000 }) //issue 158

      //issue 187
      //let sites = await getList('site',{},{ rowsPerPage: 1000 }) //issue 187
      //issue 187

      let res
      this.loading = true
      if (this.entity_id) {
        res = await getList(`audittrail/${this.entity}/${this.entity_id}`)
      } else {
        res = await getList(`audittrail/${this.entity}`, { filters: this.filters })
      }
      
      if (res.data)
      {
        //console.log(res.data)
        let jsonstr  = JSON.stringify(res.data)

        //Issue 178
        //jsonstr = jsonstr.replaceAll('"User"','"Users"')
        //Issue 178

        //Issue 179
        jsonstr = jsonstr.replaceAll('"emn_code"','"EMN Code"')
        //Issue 179

        //Issue 182
        jsonstr = jsonstr.replaceAll('"redcap_map"','"REDCap Map"')
        jsonstr = jsonstr.replaceAll('"safety_map"','"SafetyDB Map"')
        jsonstr = jsonstr.replaceAll('"ecds_map"','"eCDS Map"')
        //Issue 182

        //Issue 186
        jsonstr = jsonstr.replaceAll('"cap"','"Postal code"')
        jsonstr = jsonstr.replaceAll('"lat"','"Latitude"')
        jsonstr = jsonstr.replaceAll('"lon"','"Longitude"')
        jsonstr = jsonstr.replaceAll('"country_code"','"Country"')
        //186

        jsonstr = jsonstr.replaceAll('"protocol_roles_id"','"Protocol Roles"')
        

        //Issue 158
        jsonstr = jsonstr.replaceAll('"arms_r1"','"Arms Random 1"')
        jsonstr = jsonstr.replaceAll('"arms_r2"','"Arms Random 2"')
        jsonstr = jsonstr.replaceAll('"arms_r3"','"Arms Random 3"')
        jsonstr = jsonstr.replaceAll('"arms_r4"','"Arms Random 4"')
        jsonstr = jsonstr.replaceAll('"map_name"','"External Name"')
        jsonstr = jsonstr.replaceAll('"account_activators"','"User Activators"')
        jsonstr = jsonstr.replaceAll('"email_activators"','"User Activators Emails"')


        //issue 187
        jsonstr = jsonstr.replaceAll('"pi_first_name"','"PI_first_name"')
        jsonstr = jsonstr.replaceAll('"pi_qualification"','"PI_qualification"')
        jsonstr = jsonstr.replaceAll('"pi_email"','"PI_email"')
        jsonstr = jsonstr.replaceAll('"pi_phone"','"PI_phone"')
        //issue 187


        //issue 181
        jsonstr = jsonstr.replaceAll('"Roles"','"Protocol Roles"')
        //issue 181

        jsonstr = jsonstr.replaceAll('"Meddra"','"MedDRA"')
        

        res.data = JSON.parse( jsonstr )
        for (const e of res.data) {
          for (const f in e.fields) {
            //ISSUE 156
            if (f === 'privacy_agree')
            {
              if (e.fields[f] === 1)
              {
                e.fields[f] = 'Yes'
              }
              else
              {
                e.fields[f] = 'No'
              }
            }
            //ISSUE 156

            if (f === "uuid")
            {
              delete e.fields[f]
            }

            //issue 158
            if (f === 'User Activators')
            {
              if (Array.isArray(e.fields[f]))
              {
                let newarr = []
                for (let i = 0; i < e.fields[f].length; i++) {
                  let el = accounts.data.find(function(x) { return x.id == e.fields[f][i] });
                  if (el)
                  {
                    newarr.push(el.email)
                  }
                }         
                e.fields[f] = newarr   
              }
            }
            //issue 187

            //issue 187
            /*
            if (f === 'code')
            {
              let el = sites.data.find(function(x) { return x.code == e.fields[f] });
              if (el)
              {
                e.fields[f] = el.country.code + '-' + el.city + '-[' + el.code + ']'
              }
            }
            if (f === 'site_id')
            {
              let el = sites.data.find(function(x) { return x.id == e.fields[f] });
              if (el)
              {
                e.fields[f] = el.country.code + '-' + el.city + '-[' + el.code + ']'
              }
            }
            */
            //issue 187

          }

          for (const f in e.prev_fields) {
            //ISSUE 156
            if (f === 'privacy_agree')
            {
              if (e.prev_fields[f] === 1)
              {
                e.prev_fields[f] = 'Yes'
              }
              else
              {
                e.prev_fields[f] = 'No'
              }
            }
            //ISSUE 156

            if (f === "uuid")
            {
              delete e.prev_fields[f]
            }
            if (f === 'User Activators')
            {
              if (Array.isArray(e.prev_fields[f]))
              {
                let newarr = []
                for (let i = 0; i < e.prev_fields[f].length; i++) {
                  let el = accounts.data.find(function(x) { return x.id == e.prev_fields[f][i] });
                  if (el)
                  {
                    newarr.push(el.email)
                  }
                }         
                e.prev_fields[f] = newarr   
              }
            }
            //issue 158

            //issue 187
            /*
            if (f === 'code')
            {
              let el = sites.data.find(function(x) { return x.code == e.prev_fields[f] });
              if (el)
              {
                e.prev_fields[f] = el.country.code + '-' + el.city + '-[' + el.code + ']'
              }
            }

            if (f === 'site_id')
            {
              let el = sites.data.find(function(x) { return x.id == e.prev_fields[f] });
              if (el)
              {
                e.prev_fields[f] = el.country.code + '-' + el.city + '-[' + el.code + ']'
              }
            }
            */
            //issue 187


          }
        }
        //Issue 158

      }
      

      this.items = []
      for (const e of res.data) {
        this.items = this.items.concat(this._getChanges(e))
      }
      this.loading = false
    },
    _getChanges(entry) {

      const ignore_fields = ['id', 'restore_pass_token', 'insert_at', 'password']
      let changes = []
      for (const field_name in entry.fields) {

        if (ignore_fields.includes(field_name)) { continue }

        if (this.hideFields && this.hideFields[entry.entity] && this.hideFields[entry.entity].includes(field_name)) {
          continue
        }

        let value
        let prev_value

        // se il campo e' una foreign
        //issue 187
        var fkm = entry.foreigns_map[field_name]
        entry.prev_foreigns[fkm]
        if (fkm) {
          if (field_name === 'site_id')
          {
            if (entry.foreigns[fkm])
            {
              value = $format(fkm, entry.foreigns[fkm].code + '-' + entry.foreigns[fkm].city + '-[' + entry.foreigns[fkm].code + ']', 'audit_trail')
            }
            else
            {
              value = undefined
            }
            if (entry.prev_foreigns[fkm])
            {
              prev_value = $format(fkm, entry.prev_foreigns[fkm].code + '-' + entry.prev_foreigns[fkm].city + '-[' + entry.prev_foreigns[fkm].code + ']', 'audit_trail')
            }
            else
            {
              prev_value = undefined
            }
          }
          else
          {
            value = $format(fkm, entry.foreigns[fkm], 'audit_trail')
            prev_value = $format(fkm, entry.prev_foreigns[fkm], 'audit_trail')
          }
        } else {
          value = $format(field_name, entry.fields[field_name], field_name, 'audit_trail')
          prev_value = $format(field_name, entry.prev_fields[field_name], field_name, 'audit_trail')
        }
        //issue 187

        //issue 159
        if ( (prev_value+'').trim() == 'undefined')
        {
          prev_value = ''
        }
        if ( (value+'').trim() == 'undefined')
        {
          value = ''
        }
        if (fkm)
        {
          if (prev_value === '' && value === '')
          {
            continue;
          }
        }
        //issue 159

        // se e' un PUT metto solo i valori nuovi
        const isEdit = entry.http_verb === 'PUT' // || ['Confirm', 'Request', 'Validate', 'Save New Pdf'].includes(entry.action)

        if (Array.isArray(value) && Array.isArray(prev_value)) {
          const equal = value.length === prev_value.length && value.every((value, index) => value === prev_value[index])
          if (equal) continue
        }
        if (value === prev_value && isEdit) continue

        // non lo metto se entrambi i valori sono vuoti
        if (!value && !prev_value) continue

        //issue 235
        if(entry.action.toLowerCase() === 'delete')
        {
          value = ''
        }
        if(entry.action.toLowerCase() === 'insert')
        {
          prev_value = ''
        }
        //issue 235

        const re = new RegExp(this.entity, 'gi')
        changes.push({
          //issue 187
          action: `${entry.action}`.replace(re, ''), //`${entry.action} ${entry.section}`.replace(re, ''), // entry.http_verb,
          //issue 187
          account: entry.insert_by,
          odd: this.odd,
          datetime: entry.insert_at,
          field_name: this._getFieldLabel(field_name),
          prev_value,
          color: entry.color,
          foreign: entry.entity !== this.entity,
          value
        })
      }

      if (entry.http_verb === 'PUT' && !changes.length) {
        changes.push({
          action: entry.action,
          account: entry.insert_by,
          datetime: (entry.insert_at),
          color: entry.color,
          odd: this.odd,
          field_name: 'EMPTY UPDATE'
        })
      }

      if (changes.length) {
        this.odd = !this.odd
      }
      return changes
    }
  }
}

</script>
<style>
.odd {
  background-color: beige;
}

.audit_trail_table .v-data-table__wrapper {
  overflow-y: scroll;
  height: min(700px, 70vh);
}

.audit_trail_table td {
  word-wrap: anywhere;
}
</style>